import { HttpHeaders } from '@angular/common/http';
import { ContextApplication } from 'src/app/Context/contextapplication/contextapplication';

export class UrlServerApiUtils {

  constructor(public contextApplication: ContextApplication) {  }

  public getHeaderOptions(): HttpHeaders {
    return new HttpHeaders({ 'Content-Type': 'application/json', Authorization: this.getAuthToken() });
  }

  private getAuthToken(): string {
    if(this.contextApplication.HasUserContext){
      return 'Basic ' + btoa(this.contextApplication.Usuario.username + ':' + this.contextApplication.Usuario.password);
    }

    return 'Bearer ' + this.contextApplication.Token.access_token;
  }
}
